export default class UserDocumentation {

  id = "";
  userId = "";
  roleId = "";
  name = "";

  roleName = "";
  fileName = "";
  start = "";
  end = "";

  constructor() {
  }
}
